import type {
  TrendingStocksDurationFilter,
  TrendingStocksEntityMap,
  TrendingStocksPrimaryTab,
  TrendingStocksSelectionKey,
} from "../types";

const DURATION_ENTITY_FALLBACK: Record<TrendingStocksDurationFilter, string> = {
  all_calls: "all",
  short_term: "sterm",
  mid_term: "mterm",
  long_term: "lterm",
};

export function normalizePrimaryTab(value: unknown): TrendingStocksPrimaryTab {
  const normalized =
    typeof value === "string"
      ? value.toLowerCase().replace(/[^a-z0-9]/g, "")
      : "";
  if (normalized === "fo" || normalized === "fno" || normalized === "fand0") {
    return "fo";
  }
  return "stocks";
}

export function normalizeDurationFilter(
  value: unknown,
): TrendingStocksDurationFilter {
  const normalized =
    typeof value === "string"
      ? value.toLowerCase().replace(/[^a-z0-9]/g, "")
      : "";

  if (normalized === "sterm") {
    return "short_term";
  }
  if (normalized === "mterm") {
    return "mid_term";
  }
  if (normalized === "lterm") {
    return "long_term";
  }
  if (normalized === "all") {
    return "all_calls";
  }

  if (normalized === "shortterm" || normalized === "short") {
    return "short_term";
  }
  if (normalized === "midterm" || normalized === "mediumterm" || normalized === "mid") {
    return "mid_term";
  }
  if (normalized === "longterm" || normalized === "long") {
    return "long_term";
  }
  return "all_calls";
}

export function getSelectionKey(
  tab: TrendingStocksPrimaryTab,
  duration: TrendingStocksDurationFilter,
): TrendingStocksSelectionKey {
  return `${tab}:${duration}`;
}

export function getDurationFilterLabel(duration: TrendingStocksDurationFilter): string {
  switch (duration) {
    case "short_term":
      return "SHORT TERM";
    case "mid_term":
      return "MID TERM";
    case "long_term":
      return "LONG TERM";
    default:
      return "ALL CALLS";
  }
}

export function resolveEntityForSelection(
  entityMap: TrendingStocksEntityMap | undefined,
  tab: TrendingStocksPrimaryTab,
  duration: TrendingStocksDurationFilter,
  fallbackEntity = "all",
): string {
  const durationEntity = DURATION_ENTITY_FALLBACK[duration];
  if (durationEntity) {
    return durationEntity;
  }

  const tabEntityMap = entityMap?.[tab];
  return (
    tabEntityMap?.[duration] ??
    tabEntityMap?.all_calls ??
    entityMap?.stocks?.[duration] ??
    entityMap?.stocks?.all_calls ??
    fallbackEntity
  );
}
